import React from "react";
import { Tabs, Tab } from "react-bootstrap-tabs";
import ComparisonReport from "../comparison/ComparisonReport";
import GrowthComparisonTable from "../comparison/GrowthComparisonTable";
import GrowthComparisonChart from "../dashboard/growthComparisonChart";
import * as axiosInstance from "../utils/axiosinstace";
import { useTranslation } from 'react-i18next';

const GrowthComparison = () => {
  const { t } = useTranslation(['common', 'analytics']);
  return (
  <ComparisonReport
    title={t('analytics:compare.growthReport')}
    fetchData={axiosInstance.growthComparison_values}
    renderChart={(data) => (
      <Tabs activeHeaderStyle={{ background: "transparent" }}>
        <Tab label={t('analytics:compare.chart')}>
          <GrowthComparisonChart
            data={data}
            title={t('analytics:compare.growthCurvesTitle')}
          />
        </Tab>
        <Tab label={t('analytics:compare.table')}>
          <GrowthComparisonTable data={data} />
        </Tab>
      </Tabs>
    )}
  />
  );
};

export default GrowthComparison;
